import apiClient from "./api/apiClient";

export interface CreateRatingRequestModel {
  booking_id: string;
  product_feedback_rating: number;
  service_feedback_rating: number;
  service_feedback_tags: string[];
  product_feedback_tags: string[];
  images: string[];
  feedback_text: string;
}

export interface CreateRatingResponseModel {
  status: {
    success: boolean;
    errorMessage?: string;
  };
  data: {
    id: string;
  };
}

export interface GetFeedbackTagsResponseModel {
  status: {
    success: boolean;
    errorMessage?: string;
  };
  data: {
    product: string[];
    service: string[];
  };
}

export const getFeedbackTags = async (
): Promise<GetFeedbackTagsResponseModel | undefined> => {
  try {
    const response = await apiClient.get(
      `/feedback/tags`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return undefined;
  }
};

export const createFeedback = async (
  feedbackData: CreateRatingRequestModel
): Promise<CreateRatingResponseModel | undefined> => {
  try {
    const response = await apiClient.post<CreateRatingResponseModel>(
      `/feedback`,
      feedbackData
    );
    return response.data;
  } catch (error) {
    console.error("Error creating feedback:", error);
    return undefined;
  }
};
